import React from 'react'
import "./footernew.scss";

const Footernew = () => {
    return (
        <>
            <section className='Footer_part '>
                <div className='inner_footer'>
                    <div>
                        <img src='\asset\fooooter.svg' />
                        <p className='name_div'>2025 © Crypto Names, All Rights Reserved</p>
                    </div>
                    <div className='socials_links'>
                        <div className='sooocials'>
                            <div>
                                <h1>Links</h1>
                                <h2>Home</h2>
                                <h2>Explore</h2>
                                <h2>About</h2>
                                <h2>Community</h2>
                            </div>

                            <div>
                                <h1>Socials</h1>
                                <h2>X (Twitter)</h2>
                                <h2>Linkedin</h2>
                                <h2>Telegram</h2>
                                <h2>Discord</h2>
                            </div>
                        </div>
                        <div>
                            <h1>Docs</h1>
                            <h2>Policy</h2>
                            <h2>Terms of Service</h2>

                        </div>


                    </div>
                    <p className='footer_divv d-none'>2025 © Crypto Names, All Rights Reserved</p>
                </div>
            </section>

        </>
    )
}

export default Footernew